import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const ImagePreviewLightboxslide = ({ children, images = [], initialSlide = 0 }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(initialSlide);

  // If only one image passed as string, convert to array
  const slides = Array.isArray(images)
    ? images.map(src => ({ src }))
    : images ? [{ src: images }] : [];

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        style={{ cursor: "pointer" }}
      >
        {children}
      </div>

      {open && slides.length > 0 && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          index={index}
          slides={slides}
          on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
          carousel={{ finite: false }}
          controller={{ closeOnBackdropClick: true }}
        />
      )}
    </>
  );
};

export default ImagePreviewLightboxslide;